import { Routes } from '@angular/router';
import { UDeuHomeComponent } from './lib/components/home/home.component';
import { UDeuGuard } from './lib/guards/udeu.guard';
import { BoudComponent } from './lib/components/boud/boud.component';
import { TransferCalendarComponent } from './lib/components/transfer-calendar/transfer-calendar.component';
import { GROUP_BOUD_SITE, GROUP_LOANS_SITE, GROUP_TRANSFER_CALENDAR_SITE, GROUP_TRANSFERS_SITE, GROUP_RECORDS_SITE, GROUP_ADMINISTRATION_SITE_MANAGER } from './lib/model/contants/deusto';
import { AppLayoutComponent } from 'app/src/app/components/layout/app-layout/app-layout.component';
import { LoansComponent } from './lib/components/loans/loans.component';
import { TransfersComponent } from './lib/components/transfers/transfers.component';
import { RecordsComponent } from './lib/components/records/records.component';
import { AdministrationComponent } from './lib/components/administration/administration.component';

export const routes: Routes = [
  {
    path: 'home',
    component: UDeuHomeComponent,
  },
  {
    path: "viewer",
    component: AppLayoutComponent,
    children: [
      {
        path: "boud",
        component: BoudComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.TITLE",
          groupId: GROUP_BOUD_SITE
        }
      },
      {
        path: "loans",
        component: LoansComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.TITLE",
          groupId: GROUP_LOANS_SITE
        }
      },
      {
        path: "loans/:uuid",
        component: LoansComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.TITLE",
          groupId: GROUP_LOANS_SITE
        }
      },
      {
        path: "transfer-calendar",
        component: TransferCalendarComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.TITLE",
          groupId: GROUP_TRANSFER_CALENDAR_SITE
        }
      },
      {
        path: "transfers",
        component: TransfersComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.TITLE",
          groupId: GROUP_TRANSFERS_SITE
        }
      },
      {
        path: "transfers/:uuid",
        component: TransfersComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.TITLE",
          groupId: GROUP_TRANSFERS_SITE
        }
      },
      {
        path: "records",
        component: RecordsComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.TITLE",
          groupId: GROUP_RECORDS_SITE
        }
      },
      {
        path: "records/:uuid",
        component: RecordsComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.TITLE",
          groupId: GROUP_RECORDS_SITE
        }
      },
      {
        path: "administration",
        component: AdministrationComponent,
        canActivate: [UDeuGuard],
        data: {
          title: "DEUSTO.NEW_MENU.MENU_ITEMS.ADMINISTRATION.TITLE",
          groupId: GROUP_ADMINISTRATION_SITE_MANAGER
        }
      }
    ]
  }
];